import React from "react";
import SectionTitle from "../components/SectionTitle";
import { useLang } from "../context/LangContext";
import ContactForm from "../components/ContactForm";
import StimuliChain from "../components/StimuliChain";

const LABELS = {
  fr: ["Mécanique", "Électromagnétique", "Radiale", "Lumineux", "Énergétique"],
  en: ["Mechanical", "Electromagnetic", "Radial", "Photonic", "Energetic"],
  it: ["Meccanico", "Elettromagnetico", "Radiale", "Luminoso", "Energetico"],
  ru: ["Механический", "Электромагнитный", "Радиальный", "Световой", "Энергетический"],
};

const COPY = {
  fr: {
    eyebrow: "NOTRE THÉRAPIE",
    title: "L'exclusivité du protocole. L'exigence du résultat.",
    subtitle: "Notre thérapie signature associe 7 stimulations dans une même séance individuelle d'une heure. Chaque séquence est adaptée à votre objectif, en toute discrétion.",
    h3: "Une lecture clinique d'exception.",
    bullets: [
      "Monitoring biométrique en temps réel",
      "Protocoles adaptatifs, recommandations pilotées par IA",
      "Confidentialité au niveau médical",
      "Reporting intégré pour l'équipe médicale",
    ],
  },
  en: {
    eyebrow: "OUR THERAPY",
    title: "Exclusive protocol. Uncompromising results.",
    subtitle: "Our signature therapy combines 7 stimulations in a single 1-hour individual session. Each sequence is tailored to your objective, in complete discretion.",
    h3: "A clinical reading, refined to the detail.",
    bullets: [
      "Real-time biometric monitoring",
      "Adaptive protocols, AI-driven recommendation",
      "Medical-grade confidentiality",
      "Integrated reporting for the medical team",
    ],
  },
  it: {
    eyebrow: "LA NOSTRA TERAPIA",
    title: "L'esclusività del protocollo. L'esigenza del risultato.",
    subtitle: "La nostra terapia signature combina 7 stimolazioni in una singola sessione individuale di un'ora. Ogni sequenza è adattata al vostro obiettivo, in totale discrezione.",
    h3: "Una lettura clinica, curata nel dettaglio.",
    bullets: [
      "Monitoraggio biometrico in tempo reale",
      "Protocolli adattivi, raccomandazioni guidate da IA",
      "Riservatezza di livello medico",
      "Reportistica integrata per il team medico",
    ],
  },
  ru: {
    eyebrow: "НАША ТЕРАПИЯ",
    title: "Эксклюзивный протокол. Бескомпромиссный результат.",
    subtitle: "Наша сигнатурная терапия объединяет 7 стимуляций в одном часовом индивидуальном сеансе. Каждая последовательность адаптирована под вашу цель, при полной конфиденциальности.",
    h3: "Клиническое прочтение с безупречным вниманием к деталям.",
    bullets: [
      "Мониторинг биометрии в реальном времени",
      "Адаптивные протоколы, рекомендации на базе ИИ",
      "Медицинский уровень конфиденциальности",
      "Интегрированная отчётность для медицинской команды",
    ],
  },
};

export default function XPTherapy() {
  const { lang } = useLang();
  const c = COPY[lang] || COPY.en;
  return (
    <main className="pt-32" data-testid="page-xp">
      <section className="container-luxe py-16">
        <SectionTitle eyebrow={c.eyebrow} title={c.title} subtitle={c.subtitle} />
      </section>
      <section className="container-luxe pb-16 grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
        <div className="bg-[var(--surface-1)] hairline rounded-md p-2 md:p-4">
          <StimuliChain labels={LABELS[lang] || LABELS.en} />
        </div>
        <div>
          <h3 className="font-display text-3xl text-[var(--ink)] font-light leading-tight">{c.h3}</h3>
          <ul className="mt-6 space-y-3 text-[15px] text-[var(--text-secondary)] font-body">
            {c.bullets.map((b) => (
              <li key={b} className="flex items-start gap-3">
                <span className="text-[var(--gold)] mt-[10px] w-3 h-px bg-[var(--gold)] shrink-0" />
                <span>{b}</span>
              </li>
            ))}
          </ul>
        </div>
      </section>
      <section className="container-luxe pb-24"><ContactForm source="notre-therapie" /></section>
    </main>
  );
}
